// Format date as YYYY-MM-DD
export const formatDate = (date: Date): string => {
  return date.toISOString().split("T")[0];
};

// Get default dates (today and one month ago)
export const getDefaultDates = (): { startDate: string; endDate: string } => {
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  return {
    startDate: formatDate(oneMonthAgo),
    endDate: formatDate(today),
  };
};

export const currencyFormatter = (number: number) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
    number
  );
